import { countryManager } from '../CountryManager'
import {
  getProductArrivals,
  type CheckoutShippingOption,
} from '../../features/productArrivals/cartShippingOptions'
import {
  getProductArrivalsSplitReason,
  shouldShowSeparateProductArrivals,
} from '../../features/productArrivals/productArrivals.utils'

function getProductPromisesShownProps(
  shippingOption: CheckoutShippingOption
): Record<string, number | string> {
  const { shippingOptionName } = shippingOption
  const productArrivals = getProductArrivals(shippingOption)
  if (!productArrivals) {
    return { [`Promises Shown: ${shippingOptionName}`]: 1 }
  }
  const country = countryManager.getCountry()
  const isSplit = shouldShowSeparateProductArrivals({
    productArrivals,
    country,
  })
  return {
    [`Promises Shown: ${shippingOptionName}`]: isSplit ? 2 : 1,
    [`Promises Split Reason: ${shippingOptionName}`]:
      getProductArrivalsSplitReason({ productArrivals, country }),
  }
}

export function getProductPromisesProps(
  shippingOptions: CheckoutShippingOption[]
): Record<string, number | string> {
  const [{ orderShippingOptions }] = shippingOptions
  const props: Record<string, number | string> = {
    'Promises Fetched': orderShippingOptions
      ? Object.keys(orderShippingOptions).length
      : 1,
  }
  shippingOptions.forEach((shippingOption) => {
    Object.assign(props, getProductPromisesShownProps(shippingOption))
  })
  return props
}

export const DELIVERY_PROMISE_FETCH_SOURCE = {
  CART: 'Cart',
  CHECKOUT: 'Checkout',
} as const

type DeliveryPromiseFetchSource =
  (typeof DELIVERY_PROMISE_FETCH_SOURCE)[keyof typeof DELIVERY_PROMISE_FETCH_SOURCE]

interface GetDeliveryPromiseFetchPropsParams {
  source: DeliveryPromiseFetchSource
  hadFullAddress: boolean
  state: string | undefined
}

export function getDeliveryPromiseFetchProps({
  source,
  hadFullAddress,
  state,
}: GetDeliveryPromiseFetchPropsParams) {
  return {
    'Promise Fetch Source': source,
    'Had Full Address': hadFullAddress,
    'Promise State': state,
  }
}
